
import { openPopup } from '../modules/Popup.js';

// General code for forms with password fields & enabling submit button when all the required field are filled

jQuery(function($){
    $(`<span class="togglepassword"></span>`).insertAfter($('input[type="password"]'));

    $('.togglepassword').on('click', function(){
        let toggle = $(this);
        if (toggle.hasClass('active')){
            toggle.removeClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'password');
        }
        else{
            toggle.addClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'text');
        }
    });


    // Voor elke form
    $('form').each(function(){
        // Logica voor formulier validatie
        let form = $(this);    

        function validateForm (){
            if (formRequiredFilled(form)){
                form.find('input[type="submit"]').removeClass('btn--inactive');
            }
            else{
                form.find('input[type="submit"]').addClass('btn--inactive');
            }  
        }

        validateForm();
        form.find('input').on('change', validateForm);

        form.find('input[name="page-title"').val(document.title);

        // For gemeente pages
        var gemeente = $('.site-content.single-gemeente').data("name") || 'Onbekend (verstuurd vanaf activiteit pagina)';

        form.find('input[name="gemeente"]').val(gemeente);

        // Standaard adres automatisch ophalen
        initAddressApi('postcode', 'huisnummer', 'adres', form);
    });


    // Check of alle verplichte velden zijn ingevuld
    function formRequiredFilled(form){
        let allFilled = true;
        form.find('input[required], input.required, textarea.required, textarea[required]').each(function(){
            let value = $(this).val();
        
            if (value == ''){
                allFilled = false;
            }
        });
        
        return allFilled;
    }


    /* All redirects for all forms */
    document.addEventListener('wpcf7mailsent', function(event) {
        if (event.detail.contactFormId == '1655') { 
            window.location.href = '/bedankt-contact';
        }

        if (event.detail.contactFormId == '1671') { 
            // Get the 'brochure' field value
            let brochureField = event.detail.inputs.find(input => input.name === 'brochure');
            let brochureValue = brochureField ? encodeURIComponent(brochureField.value.toLowerCase()) : '';
    
            // Redirect with 'brochure' as a query parameter
            window.location.href = '/bedankt-brochure' + (brochureValue ? '?brochure=' + brochureValue : '');
        }

        if (event.detail.contactFormId == '2825') { 
            openPopup('popup-bedankt-activiteit');

            // Kopieer alle waardes naar het formulier 'hoe ben je hier gekomen'

            // Grab the submitted form data
            const submittedForm = event.target;

            // Grab the popup form
            const popupForm = document.querySelector('.popup__form form');
            if (!popupForm) return;

            // Map the hidden fields from submitted form to popup form
            const fieldsToCopy = [
                'page-title',
                'gemeente',
                'activiteit-datum',
                'activiteit-naam',
                'activiteit-id',
                'voornaam',
                'achternaam',
                'email'
            ];

            fieldsToCopy.forEach(name => {
                const submittedField = submittedForm.querySelector(`input[name="${name}"]`);
                const popupField = popupForm.querySelector(`input[name="${name}"]`);
                if (submittedField && popupField) {
                    popupField.value = submittedField.value;
                }
            });

        }

        if (event.detail.contactFormId == '6959'){
            window.location.href = '/';
        }
    }, false);
});



export function initAddressApi(postcode, huisnummer, adres, $form){
    let postcodeInput = $form.find('input[name=' + postcode + ']');
    let huisnummerInput = $form.find('input[name=' + huisnummer + ']');

    postcodeInput.on('input', detectChange);
    huisnummerInput.on('input', detectChange);

    function detectChange(){
        if (postcodeInput.val() && huisnummerInput.val()){
            getStreetAndCity(postcodeInput.val(), huisnummerInput.val(), adres, $form);
        }
    }
}

function getStreetAndCity(postcode, huisnummer, adres, $form){
    let url = "https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2/adressen?postcode=" + postcode + "&huisnummer=" + huisnummer;

    jQuery.ajax({
        url: url,
        headers: {"X-Api-Key": "l759f23ec1d6ad46a19db993c25ef1b523"},
        success: function(data){
            if (data._embedded){
                let straatnaam = data._embedded.adressen[0].korteNaam;
                let stad = data._embedded.adressen[0].woonplaatsNaam;

                $form.find('input[name=' + adres + ']').val(straatnaam + ' ' + huisnummer + ', ' + stad);
                $form.find('input[name=' + adres + ']').removeAttr('readonly');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            else{
                $form.find('input[name=' + adres + ']').val('Adres niet gevonden');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            
        }
    });
}
